export enum IDSentenceRecognition {
  Riconoscimento1 = '1',
  Riconoscimento2 = '2',
  Riconoscimento3 = '3',
  Riconoscimento4 = '4',
}
